import { PlanTabs } from './PlanTabs'
import { IMostUsedReservationResponse } from './Reservation'

export interface IFloorTemplate {
  id: number
  name: string
  isActive: boolean
  drawing: string
  isShared: boolean
}

export interface IFloorList {
  _id: number
  _fullLocation: string
  _floorName: string
  id: number
  blockId: number
  locationId: number
  districtId: number
  cityId: number
  countryId: number
  locationFirmId: number
  floorTemplateId: number
  floorTemplateName: string
  name: string
  blockName: string
  locationName: string
  districtName: string
  cityName: string
  countryName: string
  locationFirmName: string
  locationMapsUrl: string
  locationRedirectMapsUrl: string
  isReservable: boolean
  reservationCapacity: number
  allowedOccupancy: number
  hasDedicatedTable: boolean
  isShared: boolean
  drawing: string
  templateIsActive: boolean
  dedicateTableCount: number
  hasHealthServiceDoctor: boolean
  hasCoiffeurSaloons: boolean
  hasGYMSaloons: boolean
  hasLactationRoom: boolean
  hasParkArea: boolean
  hasMeetingRoom: boolean
  isFavorite: boolean
  rate: number
  floorProperties: {
    id: number
    name: string
    dictionaryCode: string
    value: boolean
  }[]
  translations: {
    name: string
    id: number
    language: string
  }[]
  occupancy: Occupancy
}

export interface ReservationMeta {
  selectedFloor: IFloorList | IMostUsedReservationResponse
  startDate: Date
  endDate: Date
  isAbroad: IAbroad
  planTab?: PlanTabs
  isNew: boolean
  routingType?: number
}

export interface IAbroad {
  name: string
  isAbroad: boolean
}

export enum RoutingType {
  HOME_PAGE = 1,
  CALENDAR_PAGE = 2,
}

export interface Occupancy {
  id: number
  name: string
  capacity: number
  occupied: number
  percentage: number
  type: string
  emptyPercentage: number
  listPercentange: number[]
  unavailableCount: number
  unavailablePercentage?: number
}

export interface OccupancyFilterRequest {
  id: number
  occupancyDate: string
}

export interface ISearchFloor {
  searchText?: string
  occupancyDate?: string
  myFirm?: boolean
  cityIdList?: number[]
  firmIdList?: number[]
  locationPropIdList?: number[]
  blockPropIdList?: number[]
  floorPropIdList?: number[]
  campusServicesList?: number[]
  rate?: number[]
}

export interface IFloorProperties {
  id: number
  name: string
  translatedValue: string
  type: string
  isActive: boolean
}

export interface IFloorPropertiesGroup {
  BLOCK: IFloorProperties[]
  LOCATION: IFloorProperties[]
  FLOOR: IFloorProperties[]
}

export interface IFloorFilteredDeskListRequest {
  floorId: number
  tablePropIdList: []
}

/* Map - Sidebar Floor List & Occupancy */
export interface IAuthFloorListByLocation {
  id: number
  blockId: number
  locationId: number
  districtId: number
  cityId: number
  countryId: number
  locationFirmId: number
  floorTemplateId: number
  floorTemplateName: string
  name: string
  blockName: string
  locationName: string
  districtName: string
  cityName: string
  countryName: string
  locationFirmName: string
  locationMapsUrl: string
  locationRedirectMapsUrl: string
  isReservable: boolean
  reservationCapacity: number
  allowedOccupancy: number
  hasDedicatedTable: boolean
  isShared: boolean
  drawing: string
  templateIsActive: boolean
  dedicateTableCount: number
  floorProperties: {
    id: number
    name: string
    dictionaryCode: string
    value: boolean
  }[]
  occupancy: Occupancy
}
